export enum DialogWindowResponse {
  yes = 'yes',
  no = 'no',
  close = 'close',
  ok = 'ok',
}
